export enum TransitionSpeed {
  SLOW = 'slow',
  MEDIUM = 'medium',
  FAST = 'fast',
}
